import changesJson from './changes.json';

type Changelog = Record<
  string, // major
  Record<
    string, // minor
    Record<
      string, // patch
      string[]
    >
  >
>;

const changes: Changelog = changesJson;

export default function extractChanges(fromVersion: string, toVersion: string) {
  let from = fromVersion
    .replace('v', '')
    .split('.')
    .map((v) => parseInt(v));
  const to = toVersion
    .replace('v', '')
    .split('.')
    .map((v) => parseInt(v));

  if (from.length !== 3) {
    from = [0, 0, 0];
  }

  console.debug('extractChanges() => ', from, to);

  const extractedChanges = [];

  for (let major = from[0]; major <= to[0]; major++) {
    if (!changes[major]) {
      continue;
    }

    let minors = Object.keys(changes[major]).map((v) => parseInt(v));

    if (major === from[0]) {
      minors = minors.filter((v) => v >= from[1]);
    }
    if (major === to[0]) {
      minors = minors.filter((v) => v <= to[1]);
    }

    for (const minor of minors) {
      let patches = Object.keys(changes[major][minor]).map((v) => parseInt(v));
      if (
        major + '.' + minor === from[0] + '.' + from[1] &&
        from[0] + '.' + from[1] !== to[0] + '.' + to[1]
      ) {
        patches = patches.filter((v) => v > from[2]);
      }
      if (
        major + '.' + minor === to[0] + '.' + to[1] &&
        from[0] + '.' + from[1] !== to[0] + '.' + to[1]
      ) {
        patches = patches.filter((v) => v <= to[2]);
      }

      for (const patch of patches) {
        console.debug(
          'extractChanges("%s", "%s") => v: ',
          fromVersion,
          toVersion,
          major + '.' + minor + '.' + patch,
        );
        extractedChanges.push({
          version: major + '.' + minor + '.' + patch,
          changes: changes[major][minor][patch],
        });
      }
    }
  }
  return extractedChanges;
}
